import { Application } from '../models/Application';

/**
 * Resolve what an app card should actually say.
 *
 * A device that takes an OTA reports the OTA build number, so that is the build the store must
 * show — otherwise the page advertises a release nobody is running. The binary underneath stays
 * available because the install link, and anyone tracing which IPA is on S3, still needs it.
 *
 * Shared by the apps list and the build-history view: they read the same rows, so they must not
 * disagree about which build is current.
 */
export function withDisplayFields(app: Application): Application {
  const hasOtaUpdate = !!app.otaBuildNumber;

  return {
    ...app,
    hasOtaUpdate,
    displayBuildNumber: hasOtaUpdate ? app.otaBuildNumber : app.buildNumber,
    // An OTA usually carries the binary's version, but not always: a version bump on an unchanged
    // fingerprint ships OTA-only. Fall back rather than assume they match.
    displayVersionNumber:
      hasOtaUpdate && app.otaVersionNumber
        ? app.otaVersionNumber
        : app.versionNumber,
    displayReleaseDate:
      hasOtaUpdate && app.otaReleaseDate
        ? app.otaReleaseDate
        : app.modifiedDate,
  };
}
